'use strict';

var styled = require('styled-components');
var cell = require('./cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellCheckboxStyled = styled__default.default(cell.Cell) `
  & > span {
    display: flex;
    overflow: initial;
    justify-content: center;
    align-items: center;
    padding-right: ${({ theme }) => theme.space.table.xxxs};
  }
`;

exports.CellCheckboxStyled = CellCheckboxStyled;
//# sourceMappingURL=cellCheckbox.styles.js.map
